import _extends from '@babel/runtime/helpers/extends';
import React__default, { useState } from 'react';
import { S as StatelessSideNav } from './StatelessSideNav/StatelessSideNav-Bqf4o_c-.js';

const SideNav = ({
  isInitiallyCollapsed = false,
  ...props
}) => {
  const [isCollapsed, setIsCollapsed] = useState(() => props.collapsable ? isInitiallyCollapsed : false);
  const handleToggleCollapse = nextIsCollapsed => {
    var _props$onToggleCollap;
    setIsCollapsed(nextIsCollapsed !== null && nextIsCollapsed !== void 0 ? nextIsCollapsed : false);
    (_props$onToggleCollap = props.onToggleCollapse) === null || _props$onToggleCollap === void 0 || _props$onToggleCollap.call(props, nextIsCollapsed);
  };
  return /*#__PURE__*/React__default.createElement(StatelessSideNav, _extends({}, props, {
    isCollapsed: isCollapsed,
    onToggleCollapse: handleToggleCollapse
  }));
};

export { SideNav as S };
//# sourceMappingURL=SideNav-ChLXZWG7.js.map
